import baseTemplate from './quantity-selector.html';

export default baseTemplate;
